/**
 * DATA TABLE HEADERS may have these properties set: 
  text: string
  value: string
  align?: 'start' | 'center' | 'end'
  sortable?: boolean
  filterable?: boolean
  divider?: boolean
  class?: string | string[]
  width?: string | number
  filter?: (value: any, search: string, item: any) => boolean
  sort?: (a: any, b: any) => number
 */

const facilityColWidth = '270px';
const imageColWidth = '150px';
const stateColWidth = '140px';
const countyColWidth = 'auto';
const wellsColWidth = 'auto'; // replaces county column

export default {
  sortBy: 'facilityName',
  mobileHeaders: ['facilityName', 'state', 'status'],
  energyTypes: [
    {
      name: 'Wind',
      label: 'Wind Energy',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'County',
          value: 'county',
          width: countyColWidth
        },
        {
          text: 'Cong. District',
          value: 'district'
        },
        {
          text: 'MW',
          value: 'mw'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Solar Universal',
      label: 'Solar Universal, Large-scale Solar',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'County',
          value: 'county',
          width: countyColWidth
        },
        {
          text: 'Cong. District',
          value: 'district'
        },
        {
          text: 'MW',
          value: 'mw'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Solar Small-scale ',
      label: 'Small-scale, Distributed Solar',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'County',
          value: 'county',
          width: countyColWidth
        },
        {
          text: 'Cong. District',
          value: 'district'
        },
        {
          text: 'MW',
          value: 'mw'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Battery Energy Storage',
      label: 'Battery Storage',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'County',
          value: 'county',
          width: countyColWidth
        },
        {
          text: 'Cong. District',
          value: 'district'
        },
        {
          text: 'MW',
          value: 'mw'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Natural Gas',
      label: 'Natural Gas Power Plants',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },

        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'County',
          value: 'county',
          width: countyColWidth
        },
        {
          text: 'Cong. District',
          value: 'district'
        },
        {
          text: 'MW',
          value: 'mw'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Natural Gas Drilling',
      label: 'Natural Gas Drilling Assets',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },

        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Wells',
          value: 'wells',
          width: wellsColWidth
        },
        {
          text: 'Barrels',
          value: 'barrels'
        },
        {
          text: 'Cubic Feet',
          value: 'cufeet'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Transmission Line',
      label: 'Transmission Line Assets',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },

        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Circuit Miles',
          value: 'circuitmiles'
        },
        {
          text: 'Voltage',
          value: 'voltage'
        },
        {
          text: 'MW',
          value: 'mw'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    }, {
      name: 'Transmission Substation',
      label: 'Transmission Assets',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },

        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Voltage',
          value: 'voltage'
        },
        {
          text: 'MW',
          value: 'mw'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Pipeline',
      label: 'Pipeline Assets',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },

        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Miles',
          value: 'pipeline'
        },
        {
          text: 'Capacity',
          value: 'capacity'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Other',
      label: 'Other Assets',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'County',
          value: 'county',
          width: countyColWidth
        },
        {
          text: 'Cong. District',
          value: 'district'
        },
        {
          text: 'MW',
          value: 'mw'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Nuclear',
      label: 'Other Assets',
      headers: [
        {
          text: '',
          value: 'image',
          class: 'image-header',
          sortable: false,
          width: imageColWidth
        },
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'County',
          value: 'county',
          width: countyColWidth
        },
        {
          text: 'Cong. District',
          value: 'district'
        },
        {
          text: 'MW',
          value: 'mw'
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    }
  ],
  energyTypesMobile: [
    {
      name: 'Wind',
      label: 'Wind Energy',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Solar Universal',
      label: 'Solar Universal, Large-scale Solar',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Solar Small-scale ',
      label: 'Small-scale, Distributed Solar',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Battery Energy Storage',
      label: 'Battery Storage',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Natural Gas',
      label: 'Natural Gas Power Plants',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },

        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Natural Gas Drilling',
      label: 'Natural Gas Drilling Assets',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },

        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Transmission Line',
      label: 'Transmission Line Assets',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    }, {
      name: 'Transmission Substation',
      label: 'Transmission Assets',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },

        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Pipeline',
      label: 'Pipeline Assets',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },

        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Other',
      label: 'Other Assets',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    },
    {
      name: 'Nuclear',
      label: 'Other Assets',
      headers: [
        {
          text: 'Facility',
          value: 'facilityName',
          align: 'start',
          width: facilityColWidth
        },
        {
          text: 'State/Province',
          value: 'state',
          width: stateColWidth
        },
        {
          text: 'Status',
          value: 'status',
          class: 'status-header',
          sortable: false,
          width: 0
        }
      ]
    }
  ]
};
